import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatatableRootObject, DataTablesResponse, UploadDataResult, Withdrawal, QuotaTransfer, messageValidation, Petition } from '../interfaces/interfaces.index';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { Adjudged, AdjudgedSico, ErrorAdjudgedSico } from '../interfaces/adjudged.interface';
import { UploadFile } from '../shared/upload/upload.component';
import { ScheduleAppointment } from '../interfaces/scheduleAppointment';
const endpoint = `${URL_SERVICIOS}Adjudged`;

@Injectable({
  providedIn: 'root'
})
export class AdjudgedService {

  constructor(private http: HttpClient) { }

  getAllAdjudgedDt = (tableObj: DatatableRootObject) =>
    this.http.post<DataTablesResponse<Adjudged>>(`${endpoint}/datatable`, tableObj, HTTP_OPTIONS)

  massiveAdjudged = (file: UploadFile) => this.http.post<UploadDataResult>(`${endpoint}/file`, file, HTTP_OPTIONS);

  postWithdrawal = (withdrawal: Withdrawal) =>
    this.http.post<Withdrawal[]>(`${endpoint}/withdrawal`, JSON.stringify(withdrawal), HTTP_OPTIONS)

  getQuotaTransferDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<any>>(`${endpoint}/quotaTransfer/all`, tableObj, HTTP_OPTIONS);

  getWithdrawalDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<any>>(`${endpoint}/withdrawal/all`, tableObj, HTTP_OPTIONS);

  postQuotaTransfer = (quotaTransfer: QuotaTransfer) =>
    this.http.post<QuotaTransfer[]>(`${endpoint}/quotaTransfer`, JSON.stringify(quotaTransfer), HTTP_OPTIONS)

  getScheduleAppointments = (petitionId: number, userId: number) =>
    this.http.get<ScheduleAppointment[]>(`${endpoint}/appointment?petitionId=${petitionId}&userId=${userId}`, HTTP_OPTIONS)

  postScheduleAppointment = (cita: ScheduleAppointment) =>
    this.http.post<ScheduleAppointment[]>(`${endpoint}/appointment`, JSON.stringify(cita), HTTP_OPTIONS)

  deleteScheduleAppointment = (petitionId: number, userId: number) =>
    this.http.post<ScheduleAppointment[]>(`${endpoint}/appointment/canceled?petitionId=${petitionId}&userId=${userId}`, HTTP_OPTIONS)

  postSicoStepFour = (data: any) =>
    this.http.post<any>(`${URL_SERVICIOS}SicoInteractions/StepFour`, JSON.stringify(data), HTTP_OPTIONS)

  getUsersCanceled = () =>
    this.http.post<any>(`${URL_SERVICIOS}SicoInteractions/CancelAdjudication`, HTTP_OPTIONS)

  getMassiveAdjuged = () =>
    this.http.post<AdjudgedSico>(`${endpoint}/SaveAdjudgedSico`, HTTP_OPTIONS)

  setAdjugedErrors = (errors: ErrorAdjudgedSico[]) => sessionStorage.setItem('errores', JSON.stringify(errors));

  getAdjugedErrors = () => JSON.parse(sessionStorage.getItem('errores'));

  getValidationAppoinment = (adviserId: number, fecha: string, hour: string, concessionaireId: number) =>
    this.http.get<messageValidation>(`${endpoint}/ValidationAppointment?AdviserId=${adviserId}&Date=${fecha}&Hour=${hour}&ConcessionaireId=${concessionaireId}`, HTTP_OPTIONS);

  getAdjudged = (contractNumber: string, documentNumber?: string) =>
    this.http.get<Petition>(`${endpoint}/GetAdjudged?contractNumber=${contractNumber}&documentNumber=${documentNumber}`, HTTP_OPTIONS)
}
